export default function InfoIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd"
            d="M24 12C24 18.6271 18.6271 24 12 24C5.37288 24 0 18.6271 0 12C0 5.37288 5.37288 0 12 0C18.6271 0 24 5.37288 24 12ZM12 9.40128C12.7097 9.40128 13.2853 9.9769 13.2853 10.6875V17.5117C13.2853 18.2223 12.7097 18.798 12 18.798C11.2903 18.798 10.7147 18.2223 10.7147 17.5117V10.6875C10.7147 9.97692 11.2903 9.40128 12 9.40128ZM13.2853 6.8568C13.2853 6.14712 12.7097 5.57148 12 5.57148C11.2903 5.57148 10.7147 6.1471 10.7147 6.8568V6.88024C10.7147 7.58992 11.2903 8.16556 12 8.16556C12.7097 8.16556 13.2853 7.58994 13.2853 6.88024V6.8568Z"
            fill="#2970BE"/>
    </svg>
  )
}
